module.exports = __webpack_public_path__ + "static/img/Rebar.95c6eb5b.png";